import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDrop } from "react-dnd";
import { useDispatch } from 'react-redux'
import { ContainerQuery } from 'react-container-query'
import { useSelector } from "react-redux";
import {
  DeviceType,
  FormCreationData,
  INITIALIZE_ACTION_STACK,
  SAVE_FORM_JSON,
} from "../../../../../stateManager/store/formCreation_v2/types";
import {
  deleteFixedElement,
  pushFormActionStack,
  removeElement,
  setGridSelection, setModalVisibility, setSelectedFormItemId, setSnackbarVisibility, undoDeleteElement, clearSelectedItems
} from "../../../../../stateManager/store/formCreation_v2/actions";
import { ElementWrapper } from "../components/ElementWrapper";
import { ItemTypes } from '../types/ItemTypes'
import MicroComponents from '../components/MicroComponents'
import { AppState } from "../../../../../stateManager/store";
import { getPadding, onDrop, handleContainers, getComponentFromStore, getComponents, getChildren } from "../helpers";
import { containers } from '../constants'
import { ModalRenderer } from "../components/ModalRenderer";
import { SnackBarRenderer } from "../components/SnackBarRenderer";
import { setContextMenuVisibility } from "../../../../../stateManager/store/contextMenuv2/action";
import { ContextMenu } from "../ContextMenu";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { FiTrash2, FiCopy } from "react-icons/fi"
import './canvas.css';
import ReactDOM from "react-dom";
import { myRedoStack, myUndoStack } from "../stack/Stack";
import { getMargin } from "../helpers/generateStyles";
import { removeWrapper } from "../helpers/draw-wrapper";
import { HandleContainersV3 } from "../helpers/HandleLayoutComponentsv3";
import { MouseHoverOnTree } from "../../../../../helpers/RxServices";
import { useToast } from "../../../../../helpers/commonFunction";
import { setIsDrag, setStepIndex } from "../../../../../stateManager/store/onboarding/action";
import { getCoordinates } from "../components/HighlightPlugins";
import { wizardContentInitialState } from "../helpers/wizardHelpers";
import { store } from "../../../../../stateManager";
import { avatarData, columnData, emailText, nameText, rowData } from "../components/templates/FlatlistTemplates";
import { getCanvasFixedSize } from "./utlis";

const query = {
  'sm': {
    minWidth: 0,
    maxWidth: 480,
  },
  'md': {
    minWidth: 481,
    maxWidth: 1024,
  },
  'lg': {
    minWidth: 1025
  }
}

interface IProps {
  device: any
  deviceType: DeviceType
  dimension?: any
  isCheckedIn: any
  zoomScale: any
  zoomRef?:any
}

interface StyleConfig {
  gridCols?: string;
  gridRows?: string;
  visible?: boolean;
  width?: string;
  widthMode?: string;
  height?: string;
  heightMode?: string;
  fixed?: boolean;
}

const applyStyles = (styles?: StyleConfig) => {
  const fixedRoot: any = document.getElementById("canvasFixedElement");
  if (fixedRoot && fixedRoot.firstElementChild) {
    const styleParts: string[] = [];
    if (styles?.widthMode === '%') {
      styleParts.push("width: 100% !important;");
    }
    if (styles?.heightMode === '%') {
      styleParts.push("height: 100% !important;");
    }
    if (styleParts.length > 0) {
      fixedRoot.firstElementChild.style.cssText += styleParts.join(" ");
    }
    return true;
  }
  return false;
};

const Canvas: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const { WarningToast, SuccessToast } = useToast()
  const { gridStyles, assetEditMode, selectedElementId, device: { resolution }, isCoreV3, fixedArrayV3 } = useSelector((state: any) => state.formJson);
  const isCoreV3_solo  = useSelector((state: any) => state.solo?.isCoreV3);
  const { components, componentOrder } = getComponents()
  const formDragRef = useRef<HTMLDivElement>(null);
  const contextVisibility = useSelector((state: any) => state.contextMenuv2.visibility);
  const { deviceType, isCheckedIn, zoomScale, zoomRef} = props
  const width = resolution.split('x')[0]
  const height = resolution.split('x')[1]
  const style = gridStyles[deviceType];

  const newStyles = {
    ...gridStyles?.common,
    ...style
  }
  const canvasBg = newStyles.backgroundColor || "#FFFFFF";
  const backgroundImage = (newStyles?.canvasBackgroundImage?.url != undefined && newStyles?.canvasBackgroundImage?.url != '') && newStyles?.canvasBackgroundImage?.url;
  // const canvasBg = style.backgroundColor || "#FFFFFF";
  const canvasFontFamily=gridStyles.common?.fontFamily || []
  const fontFamily=gridStyles.common?.canvasFontFamily || 'Arial'
  const component: FormCreationData = components[selectedElementId] || {};
  const elementStyle = component?.properties?.styles || {};
  const marginStyle = getMargin(elementStyle[deviceType] || {});
  const [hoveredElId, setHoveredElId] = useState<any>()
  const { guideVisible, info: onboardingInfo, isDrag } = useSelector((state: AppState) => state.onboarding)
  const idOfFixedElements: string[] = fixedArrayV3[deviceType] || ""
  const getStylesFromJsonFix: StyleConfig = components[idOfFixedElements[0]]?.properties?.styles[deviceType] || {}
  const newStyles2 = {
    ...elementStyle?.common,
    ...elementStyle?.[deviceType]
  }
  const nonDroppableAssetTypes = ['FormWizard', 'FlatList'];
  const [{ isOverCurrent, canDrop }, drop] = useDrop({
    accept: [
      ItemTypes.ELEMENT,
      ItemTypes.COMPONENT,
      ItemTypes.ASSET,
      ItemTypes.TEMPLATE
    ],
    canDrop: (item: any) => {
      // abort the drop operation if the drag and drop source is same
      if (item.type === ItemTypes.ELEMENT && !item.json?.parentId) {
        return false
      }

      if (item.json.type === 'Spacer') {
        return false
      }

      // you can only drop one element to the main canvas
      // when asset edit mode is turned on
      if (assetEditMode.isEnabled && componentOrder.length) {
        return false
      }

      if (nonDroppableAssetTypes.includes(item?.json?.type) && assetEditMode.isEnabled) {
        return false
      }

      return true;
    },
    collect: (monitor) => {
      return {
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
      };
    },
    drop: (item: any) => {
      if (isOverCurrent) {
        if (isCheckedIn) {
          let id: any;
          if (item?.json?.type !== 'FormWizard') {
            id = onDrop({id: ""}, item, deviceType, isCoreV3)
          }
          if (isDrag && guideVisible) {
            dispatch(setIsDrag(!isDrag))
            dispatch(setSelectedFormItemId({id, isAssetInstanceSelected: false}))
            dispatch(setStepIndex(onboardingInfo.stepIndex + 1))
          }
          if (item?.json?.type === "FormWizard") {
             onDrop({id: ''}, {type: ItemTypes.FORMWIZARD, json: {}}, deviceType, isCoreV3);
          }else if (item?.json?.type === "TabBar" && item?.type !== "Asset") {
            let data: any = {
              type: "Component",
              json: {
                type: 'Tab',
                label: 'Tab 1',
                value: "tab 1"
              }
            }
            onDrop({ id }, data, deviceType, isCoreV3)
          } else if (item?.json?.type === "FlatList") {
            // Default design for Flat list
            const rowId: any = onDrop({ id }, rowData, deviceType, isCoreV3)
            onDrop({ id: rowId }, avatarData, deviceType, isCoreV3)
            const colId: any = onDrop({ id: rowId }, columnData, deviceType, isCoreV3)
            onDrop({ id: colId }, nameText, deviceType, isCoreV3)
            onDrop({ id: colId }, emailText, deviceType, isCoreV3)
          }
        } else {
          WarningToast("Please Checkout The Form!!")
        }
      }
    },
  });

  const isActive = isOverCurrent && canDrop;
  const animationClass = isActive ? "drop-active" : canDrop ? "drop-passive" : "";

  /* styles */
  const padding = getPadding(style)
  /* === */

  const handleSelectGrid = async () => {
    // highlight the canvas on click
    const wrapper = document.getElementById("mainGrid")
    if (wrapper) {
      wrapper.style.border = !selectedElementId ? "2px solid #fe4365" : "none"
    }
    const existingWrapper = document.getElementById("wrapper");
    existingWrapper && await existingWrapper.remove();
    const type = component.type;
    if(type !== "SnackBar"){
      await dispatch(setSnackbarVisibility({ visible: false, componentId: "" }));
    }
    await dispatch(setGridSelection({ isGridSelected: true }))
    await dispatch(clearSelectedItems());
  }

  useEffect(() => {
    dispatch({
      type: INITIALIZE_ACTION_STACK,
    });
  }, [dispatch]);

  //Context Menu
  const contextMenuListener = (e: MouseEvent) => {
    if (formDragRef && formDragRef.current) {
      e.preventDefault();
  
      const rect = formDragRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
  
      const zoomScale = zoomRef?.current?.state?.scale || 1;
  
      const adjustedX = x / zoomScale;
      const adjustedY = y / zoomScale;
  
      const canvasWidth = rect.width / zoomScale;
      const canvasHeight = rect.height / zoomScale;
  
      let menuLeft = adjustedX;
      let menuTop = adjustedY;
  
      if (adjustedX > canvasWidth - 165) {
        menuLeft = canvasWidth - 165;
      }
  
      if (adjustedY > canvasHeight - 150) {
        menuTop = canvasHeight - 150;
      }
  
      dispatch(
        setContextMenuVisibility({
          visibility: true,
          coordinates: {
            top: menuTop + 10,
            left: menuLeft,
          },
        })
      );
    }
  };  

  useEffect(() => {
    const tab = document.getElementById("mainCanvas");
    if (isCheckedIn && tab && tab.getAttribute("contextlistener") !== "true") {
      tab.addEventListener("contextmenu", contextMenuListener);
      if (tab) {
        tab.setAttribute("contextlistener", "true");
      }
    }
    return () => {
      if (isCheckedIn && tab) {
        tab.removeEventListener("contextmenu", contextMenuListener);
        tab.setAttribute("contextlistener", "false");
      }
    };
    // eslint-disable-next-line
  }, [isCheckedIn])

  const clickListener = useCallback((e: any) => {
    if (e.target.id !== "contextMenuItem" && contextVisibility) {
      dispatch(setContextMenuVisibility({
        visibility: false,
        coordinates: {},
      }))
    }
  }, [contextVisibility, dispatch])

  useEffect(() => {
    const root = document.getElementById("root")

    if (root && root.getAttribute("clickListener") !== "true") {
      root.addEventListener("click", clickListener);
      root.setAttribute("clickListener", "true");
    }

    return () => {
      if (root) {
        root.removeEventListener("click", clickListener);
        root.setAttribute("clickListener", "false");
      }
    };
  }, [clickListener])

  useEffect(() => {
    const subscription = MouseHoverOnTree.getMessage().subscribe(function (e) {
      setHoveredElId(e);
    });
    if (!subscription) {
      MouseHoverOnTree.getMessage();
    }
    return () => {
      subscription.unsubscribe();
    };
  }, [hoveredElId]);

  useEffect(() => {
    canvasFontFamily &&
      canvasFontFamily.length > 0 &&
      canvasFontFamily.map((ff: any) => {
        const fontName = ff?.name;
        const link = document.createElement("link");
        link.href = ff?.url;
        link.rel = "stylesheet";
        document.head.appendChild(link);
        const notAllowed = ['swap'];
        if (!notAllowed.includes(ff?.name)) {
          const fontFaceStyle = `@font-face {
            font-family: '${fontName}';
            src:  url('${ff?.url}') ;
          }`;
          const style = document.createElement("style");
          style.appendChild(document.createTextNode(fontFaceStyle));
          document.head.appendChild(style);
          document.body.style.fontFamily = fontName;
        }
        return () => {
          document.head.removeChild(link);
          document.head.removeChild(style);
          document.body.style.fontFamily = "";
        };
      });
  }, [canvasFontFamily]);

  const getLayoutClassName = (style: any) => {
    // if not core v3 then apply grid styles
    if (isCoreV3_solo === false) {
      return `grid ${style.gridCols && `grid-cols-${style.gridCols}`} ${style.gridRows && `grid-rows-${style.gridRows}`}`;
    }

    // if core v3 then
    //
    //
    if (style.layout === "Grid") {
      return `grid ${style.gridAutoRows} ${style.gridCols && `grid-cols-${style.gridCols}`} ${style.gridRows && `grid-rows-${style.gridRows}`}`;
    }
    else if (style.layout === "Flex") {
      // Flex Direction
      let flexDirection = ""
      if (style.flexDirection === "Row") {
        flexDirection = "flex-row";
      } else if (style.flexDirection === "Column") {
        flexDirection = "flex-col"
      }
      // Align Items
      let alignItems = "";
      if (style.flexAlignItems === "Normal") {
        alignItems = "";
      } else if (style.flexAlignItems === "Center") {
        alignItems = "items-center"
      } else if (style.flexAlignItems === "Flex Start") {
        alignItems = "items-start"
      } else if (style.flexAlignItems === "Flex End") {
        alignItems = "items-end"
      } else if (style.flexAlignItems === "Stretch") {
        alignItems = "items-stretch"
      } else if (style.flexAlignItems === "Baseline") {
        alignItems = "items-baseline"
      }
      // Justify Content
      let justifyContent = "";
      if (style.flexJustifyContent === "Normal") {
        justifyContent = "";
      } else if (style.flexJustifyContent === "Center") {
        justifyContent = "justify-center"
      } else if (style.flexJustifyContent === "Flex Start") {
        justifyContent = "justify-start"
      } else if (style.flexJustifyContent === "Flex End") {
        justifyContent = "justify-end"
      } else if (style.flexJustifyContent === "Space Between") {
        justifyContent = "justify-between"
      } else if (style.flexJustifyContent === "Space Around") {
        justifyContent = "justify-around"
      } else if (style.flexJustifyContent === "Space Evenly") {
        justifyContent = "justify-evenly"
      }
      return `flex 
              ${flexDirection} 
              ${style.flexWrap ? "flex-wrap" : "flex-nowrap"} 
              ${alignItems && alignItems} 
              ${justifyContent && justifyContent}`;
    }
    else {
      return "";
    }
  }

  function getNestedComponents(fields: string[], array: FormCreationData[] = []) {
    fields.forEach((fieldId: string) => {
      const component = components[fieldId];
      array.push(component);
      // recursively all fields
      if (component?.fields?.length) {
        getNestedComponents(component.fields, array);
      }
    })
  }
  // Handle delete the selected element
  const handleDelete = async (selectedElementId: any) => {
    const childrenArray: FormCreationData[] = [];
    // remove the selectedElement
    dispatch(setSelectedFormItemId({ id: "", isAssetInstanceSelected: false }))
    getNestedComponents(component?.fields, childrenArray);
    const payload: FormCreationData = {
      ...component,
      id: components[selectedElementId].id,
      parentId: components[selectedElementId].parentId || "",
      type: components[selectedElementId].type,
      children: childrenArray,
    }

    if (components[selectedElementId].parentId) {
      const parentId: any = components[selectedElementId].parentId;
      payload.metadata = {
        position: components[parentId].fields.indexOf(components[selectedElementId].id)
      }
    }

    // Undo Redo for delete elements
    myUndoStack.push({ ...payload });
    // component order
    myUndoStack.saveOrder(componentOrder);
    const order = myUndoStack.getOrder();

    dispatch(pushFormActionStack({
      undo: () => {
        const poppedElement = myUndoStack.pop();
        if (poppedElement) {
          myRedoStack.push(poppedElement);
          dispatch(
            undoDeleteElement(poppedElement, order),
          )
        }
      },
      redo: () => {
        const poppedElement = myRedoStack.pop();
        if (poppedElement) {
          myUndoStack.push({ ...poppedElement });
          dispatch(removeElement({
            id: poppedElement.id,
            parentId: poppedElement.parentId || "",
            type: poppedElement.type,
            increment: 1
          }))
        }
      }
    }));
    dispatch(removeElement({
      id: selectedElementId,
      parentId: components[selectedElementId].parentId,
      type: components[selectedElementId].type
    }));
    
    const fixedElement = component?.properties?.styles?.[deviceType]?.fixed || false
    if (fixedElement === true) {
      dispatch(deleteFixedElement(selectedElementId));
    }

    // Remove the highlight wrapper if the last element is deleted
    const remainingElements = Object.keys(components).filter(id => id !== selectedElementId);
    const numberOfElementsBeforeDeletion = Object.keys(components).length;
    const numberOfElementsAfterDeletion = remainingElements.length;

    // Check if the last element has been deleted
    if (numberOfElementsBeforeDeletion === 1 && numberOfElementsAfterDeletion === 0) {
      const existingWrapper = document.getElementById("wrapper");
      if (existingWrapper) {
        existingWrapper.remove();
      }
    }
  }
  // Handle copy the selected element
  const handleCopy = async (selectedElementId: string) => {
    const rootComponent = { ...components[selectedElementId] }
    const copiedComponents: any = {
      [selectedElementId]: rootComponent
    }

    const componentIds = getChildren(rootComponent.fields, components)
    componentIds.forEach(id => {
      copiedComponents[id] = { ...components[id] }
    })

    const data = {
      componentOrder: [selectedElementId],
      components: copiedComponents,
    }

    try {
      await navigator.clipboard.writeText(JSON.stringify(data));
      SuccessToast("Copied to clipboard");
    } catch (err) {
      console.error("failed to copy text: ", err);
    }
  };

  function drawWrapper(selectedElementId: string) {
    const existingWrapper = document.getElementById("wrapper");
    if (existingWrapper) {
      existingWrapper.remove();
    }
    const selectedElement = selectedElementId ? components[selectedElementId] : {};
    if (selectedElement) {
      const mainGrid:any = document.getElementById("mainGrid");
      if (selectedElementId && isCoreV3) {
        const type = components[selectedElementId]?.type;
        const elem = document.getElementById(`${type}-${selectedElementId}`);
        const { top, left ,bottom,right} = getCoordinates(elem, document.getElementById("mainGrid"));
        const { parentId } = selectedElement
        let selectedParent: any;
        if (parentId) {
          const parentElement = components[parentId]
          selectedParent = document.getElementById(`${parentElement?.type}-${parentId}`)
        } else {
          selectedParent = mainGrid
        }
        if (elem) {
          const highlightDiv = document.createElement("div");
          highlightDiv.id = "wrapper";
          highlightDiv.style.maxHeight = "100%";
          highlightDiv.style.position = "absolute";
          highlightDiv.style.border = "1.65px solid #fe4365";
          highlightDiv.style.borderRadius = "2px";
          highlightDiv.style.pointerEvents = "none";
          highlightDiv.style.zIndex = '9999';

        if (type !== "FAB") {
          highlightDiv.style.top = "0px";
          highlightDiv.style.left = "0px";
        }

        if(type === "Tab"){
          highlightDiv.style.display = "none"
        }

        if(isChildAsset && !assetEditMode.isEnabled){
          highlightDiv.style.display = "none"
        }

        if (type === "FAB") {
          highlightDiv.style.bottom = `${bottom}px`;
          highlightDiv.style.right = `${right}px`;
          highlightDiv.style.maxHeight = "unset"
        }

        if (elem && elem.clientWidth && elem.clientHeight) {
          highlightDiv.style.width = `${elem.clientWidth}px`;
          highlightDiv.style.height = `${elem.clientHeight}px`;
        }
        // Create the selected element ID display
        const selecteid = document.createElement("p");
        selecteid.setAttribute("id", "selectedElementId");
        selecteid.style.fontSize = "11px";
        selecteid.style.position = "absolute";
        selecteid.style.background = "#fe4365";
        selecteid.style.borderRadius = "2px";
        selecteid.style.padding = "2px";
        selecteid.style.color = "#fff";
        selecteid.style.bottom = `0px`;
        selecteid.style.left = `0px`;
        selecteid.innerHTML = selectedElementId;
        highlightDiv.appendChild(selecteid);

        // create and append the trash and copy icon
        const trashAndCopyWrapper = document.createElement("div");
        trashAndCopyWrapper.className = "trash-icons";
        trashAndCopyWrapper.style.display = "flex";
        trashAndCopyWrapper.style.flexDirection = "row";
        trashAndCopyWrapper.style.justifyContent = "space-between";
        trashAndCopyWrapper.style.width = "40px";
        trashAndCopyWrapper.style.fontSize = "11px";
        trashAndCopyWrapper.style.position = "absolute";
        trashAndCopyWrapper.style.borderRadius = "2px";
        trashAndCopyWrapper.style.padding = "2px";
        trashAndCopyWrapper.style.bottom = `0px`;
        trashAndCopyWrapper.style.right = `0px`;
        trashAndCopyWrapper.style.pointerEvents = 'none';

        // Create and render the trash (delete) icon
        const trashIconElement = document.createElement("div");
        trashIconElement.style.pointerEvents = 'auto';
          {
            isCheckedIn && ReactDOM.render(
              <TrashIcon
                selectedElementId={selectedElementId}
                handleDelete={() => handleDelete(selectedElementId)}
              />,
              trashIconElement
            );
            trashAndCopyWrapper.appendChild(trashIconElement);
          }
        // Create and render the copy icon
        const copyIconElement = document.createElement("div");
        copyIconElement.style.pointerEvents = 'auto';
        ReactDOM.render(
          <CopyIcon
            selectedElementId={selectedElementId}
            handleCopy={() => handleCopy(selectedElementId)}
          />,
          copyIconElement
        );
        trashAndCopyWrapper.appendChild(copyIconElement);
        // Add the icons to the highlightDiv
        highlightDiv.appendChild(trashAndCopyWrapper);
        highlightDiv.style.pointerEvents = 'none';

        // Append the created elements to the selected node
        if (selectedParent) {
          if (selectedElement.type === "Row" || 
          selectedElement.type === "Column" || 
          selectedElement.type === "Grid" || 
          selectedElement.type === "CustomModal" ||
          selectedElement.type === "A8Modal" ||
          selectedElement.type !== "TabBar" ||
            selectedElement.type === "ExpansionPanel") {
            const existingWrapper = document.getElementById("wrapper");
            if (existingWrapper) {
              existingWrapper.remove();
            }
            elem?.appendChild(highlightDiv)
          } else {
            existingWrapper && existingWrapper.remove();
            const selectedElem = document.getElementById(selectedElementId)
            selectedElem?.appendChild(highlightDiv);
          }
          }
        }
      } else if (!selectedElementId) {
        if (existingWrapper) {
          existingWrapper.style.display = "none";
        }
        return;
      }
    }
  }

  const dynamicClassName = isCoreV3
  ? `
      ${getLayoutClassName(style)}
      transform relative ${animationClass}
    `
  : `grid ${style.gridCols && `grid-cols-${style.gridCols}`} ${style.gridRows && `grid-rows-${style.gridRows}`} transform relative ${animationClass}`;


  // drawWrapper when selectedElementId changes
  useEffect(() => {
    if (selectedElementId) {
      drawWrapper(selectedElementId)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedElementId])

  // redraw the wrapper when page/component is scrolled
  const handleScroll = () => {
    drawWrapper(selectedElementId);
  };

  // Render wrapper while scroll
  useEffect(() => {
    const mainGrid: any = document.getElementById("mainGrid");
    if (mainGrid) {
      mainGrid.addEventListener('scrollend', handleScroll);
      mainGrid.addEventListener("scroll", removeWrapper);
    }

    return () => {
      mainGrid.removeEventListener('scrollend', handleScroll);
      mainGrid.removeEventListener('scroll', removeWrapper);
    };
  }, [selectedElementId]);

  // Move wrapper while update properties
  useEffect(() => {
    if (!selectedElementId) {
      return;
    }
    let observer: ResizeObserver | null = null;
    const type = components[selectedElementId]?.type;
    const element = document.getElementById(`${type}-${selectedElementId}`);
    function handleResize() {
      drawWrapper(selectedElementId);
    }
    if (element) {
      observer = new ResizeObserver(entries => {
        entries.forEach(entry => {
          handleResize();
        });
      });
      observer.observe(element);
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [marginStyle]);

  useEffect(() => {
      drawWrapper(selectedElementId)
  }, [
    newStyles2.width,
    newStyles2.widthMode,
    newStyles2.height,
    newStyles2.heightMode,
    newStyles2.padding,
    newStyles2.paddingTop,
    newStyles2.paddingBottom,
    newStyles2.paddingLeft,
    newStyles2.paddingRight,
    newStyles2.margin,
    newStyles2.marginTop,
    newStyles2.marginBottom,
    newStyles2.marginLeft,
    newStyles2.marginRight,
    newStyles2.backgroundImage
    , component.label]);
    const { isAsset, isChildAsset } = component


  const handleRightClick = async (e: React.MouseEvent<HTMLDivElement>, id: any) => {
    e.stopPropagation();
    const existingWrapper = document.getElementById("wrapper");
    existingWrapper && await existingWrapper.remove();
    await dispatch(
      setSelectedFormItemId({
        id,
        isAssetInstanceSelected: isAsset || isChildAsset,
      })
    );
    await dispatch(clearSelectedItems());
  };

  const getCanvasFixedWidth = useMemo((): string => {
    return getCanvasFixedSize(getStylesFromJsonFix?.widthMode, "width", getStylesFromJsonFix?.width);
  }, [getStylesFromJsonFix?.width, getStylesFromJsonFix?.widthMode]);

  const getCanvasFixedHeight = useMemo((): string => {
    return getCanvasFixedSize(getStylesFromJsonFix?.heightMode, "height", getStylesFromJsonFix?.height);
  }, [getStylesFromJsonFix?.height, getStylesFromJsonFix?.heightMode]);

useEffect(() => {
  if (applyStyles(getStylesFromJsonFix)) return;
  const observer = new MutationObserver(() => {
    if (applyStyles(getStylesFromJsonFix)) {
      observer.disconnect();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  return () => observer.disconnect();
}, [getStylesFromJsonFix?.height, getStylesFromJsonFix?.heightMode, getStylesFromJsonFix?.width, getStylesFromJsonFix?.widthMode]);

  return (
    <div
      ref={formDragRef}
      id="mainCanvas"
      onClick={handleSelectGrid}
      onContextMenu={handleSelectGrid}
      style={{
        height: height + "px",
        width: width + "px",
        fontFamily: fontFamily || 'Arial',
        backgroundColor: canvasBg,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: newStyles?.canvasBackgroundImage?.size || 'cover',
        backgroundRepeat: newStyles?.canvasBackgroundImage?.repeat || 'no-repeat',
      }}
      className="mainCanvas overflow-auto relative border tour_mainCanvas"
    >
      <div
        id="mainGrid"
        ref={ref => drop(ref)}
        //Giving height to Initial drop space
        style={{ ...padding, height: '100%',  gridAutoRows: 'min-content', overflow: "auto", gap: ((isCoreV3 ? (style.layout === "Grid" && style.gap) :  style.gap)) ? `${style.gap}px` : '0px' }}
        className={dynamicClassName}
      >
        {componentOrder.map((componentId: string, index: number) => {
          const elements = getComponentFromStore(componentId)
          if (!elements) {
            return null
          }
          const { component, parentComponent } = elements

          const onClickHandler = (e: any) => {
            e.stopPropagation();
            dispatch(
              setSelectedFormItemId({
                id: component.id,
                isAssetInstanceSelected: isAsset || isChildAsset,
              }))
          }
        
          return (
            <>
              {isCoreV3 ?
               <>
                  {containers.includes(component.type) ? (
                    <HandleContainersV3 isCheckedIn={isCheckedIn} element={component} deviceType={deviceType} zoomScale={zoomScale} index={index} />
                  ) : (
                    <MicroComponents
                      zoomScale={zoomScale}
                      deviceType={deviceType}
                      element={component}
                      key={componentId}
                      parentElement={parentComponent}
                      index={index}
                      isCheckedIn={isCheckedIn}
                      isRootChildren={true}
                    />
                  )}
                </>
                :
                <ElementWrapper
                key={componentId}
                element={component}
                parentElement={parentComponent}
                index={index}
                isCheckedIn={isCheckedIn}
                isRootChildren={true}
              >
                <div style={{ backgroundColor: hoveredElId === component.id ? "#EFF0F4" : "" }}
                  onClick={e => onClickHandler(e)}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    handleRightClick(e,component.id);
                  }}
                  onMouseOver={(e) => {
                    e.stopPropagation();
                    MouseHoverOnTree.sendMessage(component.id)
                  }}
                  onMouseLeave={() => { MouseHoverOnTree.sendMessage(null) }}
                > {containers.includes(component.type) ? (
                  handleContainers({ isCheckedIn: isCheckedIn, element: component, deviceType, zoomScale })
                ) : (
                  <MicroComponents
                    zoomScale={zoomScale}
                    deviceType={deviceType}
                    element={component}
                  />
                )}</div>
              </ElementWrapper>
              }
            </>
          );
        })}
      </div>
      <div id="canvasFixedElement" style={{ width: getCanvasFixedWidth ? getCanvasFixedWidth : "100%", height: getCanvasFixedHeight ? getCanvasFixedHeight : "82px" }} className="fixed bottom-0 left-0 bg-white"></div>
      <SnackBarRenderer deviceType={deviceType} />
      <div onClick={(e: any) => {
        e.stopPropagation()
        if (e.target.id === `a8modal_${selectedElementId}`) {
          dispatch(setModalVisibility({ visible: false, componentId: "" }))
          dispatch(setSelectedFormItemId({ id: "", isAssetInstanceSelected: false, shouldSelectGrid: true }));
        }
      }}
      onContextMenu={(e) => {
        e.preventDefault();
        handleRightClick(e,selectedElementId);
      }}>
        <ModalRenderer isCoreV3={isCoreV3} deviceType={deviceType} isCheckedIn={isCheckedIn}/>
      </div>
      <ContextMenu />
    </div>
  )
}

export const FormDesigner = (props: any) => {
  const deviceType = useSelector((state: AppState) => {
    return state.formJson.deviceType
  })

  const device = useSelector((state: AppState) => {
    return state.formJson.device
  })

  const { viewRef, zoomRef, onZoomStop, setTransform, isCheckedIn, setZoomScale, zoomScale } = props

  useEffect(() => {
    // Ref will not be set on initial load while passed as a prop, hence any initial transformation needs a timeout
    setTimeout(() => {
      setTransform(zoomRef, 'fit')
      setZoomScale("Auto")
      viewRef?.current?.scrollIntoView({ behavior: 'auto', block: "center", inline: "center" });
    }, 0)
  }, [setTransform, device?.resolution, zoomRef])

  return (
    <TransformWrapper
      ref={zoomRef}
      panning={{ activationKeys: [' '] }}
      wheel={{ wheelDisabled: true }}
      centerOnInit={true}
      centerZoomedOut={false}
      zoomAnimation={{ disabled: true }}
      velocityAnimation={{ disabled: true }}
      alignmentAnimation={{ disabled: true }}
      doubleClick={{ disabled: true }}
      minScale={0.5}
      maxScale={2}
      limitToBounds={false}
      onZoomStop={onZoomStop}
    >
      <TransformComponent wrapperClass={"zoom"} wrapperStyle={{ width: `600%`, height: `600%`, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div ref={viewRef} style={{ backgroundColor: "transparent", width: '100%' }}>
          <span>
            <span>{device.name} - {device.resolution}</span>
          </span>
          <ContainerQuery query={query}>
            {(params) => <Canvas isCheckedIn={isCheckedIn} zoomScale={zoomScale} device={params} deviceType={deviceType} zoomRef={zoomRef} />}
          </ContainerQuery>
        </div>
      </TransformComponent>
    </TransformWrapper>
  )
};


const TrashIcon = (props: any) => {
  const { handleDelete, selectedElementId } = props;
  return (
    <FiTrash2
      size={"14px"}
      color="#F32727"
      style={{ cursor: "pointer" }}
      onClick={() => handleDelete(selectedElementId)}
    />
  );
};


const CopyIcon = (props: any) => {
  const { handleCopy, selectedElementId } = props;
  return (
    <FiCopy
      size={"14px"}
      color="#121212"
      style={{ cursor: "pointer" }}
      onClick={() => handleCopy(selectedElementId)}
    />
  );
};